import { render, staticRenderFns } from "./garden_enter3.vue?vue&type=template&id=8cb6578e&scoped=true&"
import script from "./garden_enter3.vue?vue&type=script&lang=js&"
export * from "./garden_enter3.vue?vue&type=script&lang=js&"
import style0 from "./garden_enter3.vue?vue&type=style&index=0&id=8cb6578e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb6578e",
  null
  
)

export default component.exports